import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Link } from '@paypalcorp/pp-react';
import OptimizedImage from './OptimizedImage';
import { parseData } from '../../../lib/helpers';

const BannerTile = props => {
  const { content, fptiClick, fptiImpression } = props;
  const {
    categoryHeader: header,
    categoryTitle: title,
    categoryBannerImageUrl: imageUrl,
    categoryBody: body,
    categoryFPTI,
    cta
  } = content || {};

  const parsedCta = parseData(cta);
  const ctaText = parsedCta[0]?.text;
  const ctaUrl = parsedCta[0]?.url;

  useEffect(() => {
    fptiImpression({
      pageLink: categoryFPTI + '_banner',
      category: 'parent'
    });
  }, []);

  const handleClick = fptiLink => {
    fptiClick({
      fptiLink: (typeof fptiLink === 'string' && fptiLink) || categoryFPTI,
      category: 'parent',
      pageLink: categoryFPTI + '_banner'
    });
  };

  return (
    <section id="appcenter-banner-tile">
      <div className="banner-wrapper">
        <div className="description-container">
          <div className="body-wrapper">
            <div className="body-text">
              <h2>{header}</h2>
              <p>{body}</p>
            </div>
            <div className="body-button">
              <Button
                className="get-started-button"
                size="sm"
                secondary
                as={Link}
                onClick={handleClick}
                href={ctaUrl}
              >
                {ctaText}
              </Button>
            </div>
          </div>
        </div>
        <div className="image-container">
          <OptimizedImage
            imageUrl={imageUrl}
            className={`banner-image`}
            title={title}
          />
        </div>
      </div>
    </section>
  );
};

BannerTile.propTypes = {
  content: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func
};

export default BannerTile;
